<template>
  <fragment>
    <AppBody
      title="Formas de Pagamento / Gerenciar"
      subtitle="Formas de Pagamento"
      :actions="actions"
    >
      <CardModule untitle>
        <ExpansionPanelFilters>
          <v-form
            @submit.prevent="$financeiro_formas_pgto.filtroFormasPgto()"
            class="search-forms"
          >
            <v-row>
              <v-col cols="12" md="3" sm="4">
                <BaseTextField
                  label="Descrição"
                  placeholder="Insira a descrição"
                  v-model="$financeiro_formas_pgto.filter.descricao"
                >
                </BaseTextField>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseSelect
                  label="Status"
                  placeholder="Selecione o status"
                  :items="$financeiro_formas_pgto.status"
                  item-text="text"
                  item-value="value"
                  v-model="$financeiro_formas_pgto.filter.status"
                  clearable
                  @click:clear-icon="clearFilterFields('status')"
                >
                </BaseSelect>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseSelect
                  label="Tipo de Pessoa"
                  placeholder="Selecione o tipo de pessoa"
                  :items="$financeiro_formas_pgto.canal_venda"
                  item-text="text"
                  item-value="value"
                  v-model="$financeiro_formas_pgto.filter.canal_venda"
                ></BaseSelect>
              </v-col>
              <v-col cols="12" md="3" sm="4" v-if="isLoja">
                <template>
                  <BaseAutocomplete
                    label="Selecione a Loja"
                    v-model="$financeiro_formas_pgto.filter.loja"
                    :items="$loja_gerenciar.lojas"
                    clearable
                    :error-messages="$financeiro_formas_pgto.filter.error.loja"
                    @input="$financeiro_formas_pgto.filter.error.loja = []"
                    :filter="searchLoja"
                    item-text="nome_loja"
                    item-value="sequenciador"
                    no-data-text="Nenhuma loja encontrada"
                  >
                    <template v-slot:selection="{ item }">
                      {{ item.nome_loja }}
                    </template>
                  </BaseAutocomplete>
                </template>
              </v-col>
              <v-col class="d-flex justify-end">
                <BaseButton
                  variant="filter"
                  type="submit"
                  :loading="$financeiro_formas_pgto.filter_loading"
                >
                  Filtrar
                </BaseButton>
              </v-col>
            </v-row>
          </v-form>
        </ExpansionPanelFilters>

        <v-data-table
          class="table-body"
          no-data-text="Nenhum registro encontrado"
          loading-text="Buscando informações..."
          :headers="headersFormaPgto"
          :items="$financeiro_formas_pgto.formas_pagamento"
          :items-per-page="10"
          sort-by="descricao"
          :loading="$financeiro_formas_pgto.formas_pgto_loading"
          mobile-breakpoint="0"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 50],
            itemsPerPageText: 'Formas de pagamento por página:',
          }"
        >
          <template v-slot:item.actions="{ item }" class="table-actions">
            <div style="display: flex; justify-content: center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="$config.dados.corinputs"
                    height="30"
                    width="30"
                    small
                    icon
                    :loading="item.edit_button_loading"
                    v-bind="attrs"
                    v-on="on"
                    @click="openModal('edit', item)"
                    class="mr-2"
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="$config.dados.corinputs"
                    height="30"
                    v-bind="attrs"
                    v-on="on"
                    width="30"
                    small
                    icon
                    @click="
                      $financeiro_formas_pgto.remover(
                        item.idforma_pag,
                        'Deseja realmente excluir esta forma de pagamento?'
                      )
                    "
                  >
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Deletar</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
        <FinanceiroFormasPagamentoAdd />
      </CardModule>
    </AppBody>
    <ModalConfirmacao
      :textModal="$financeiro_formas_pgto.text"
      @callback="$financeiro_formas_pgto.funcaoRemover"
    />
  </fragment>
</template>

<script>
export default {
  name: "PaymentMethods",
  metaInfo: {
    title: "Formas de pagamento | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Formas de pagamento | ElevenTickets",
      },
    ],
  },
  props: {},
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    CardModule: () => import("@/components/cards/CardModule.vue"),
    BaseTextField: () => import("@/components/forms/BaseTextField.vue"),
    BaseAutocomplete: () => import("@/components/forms/BaseAutocomplete.vue"),
    BaseSelect: () => import("@/components/forms/BaseSelect.vue"),
    BaseButton: () => import("@/components/forms/BaseButton.vue"),
    FinanceiroFormasPagamentoAdd: () =>
      import(
        "@/components/financeiro/financeiro-modal-formas-pagamento-add.vue"
      ),
    ModalConfirmacao: () => import("@/components/global/modal-confirmacao.vue"),
    ExpansionPanelFilters: () =>
      import("@/components/forms/ExpansionPanelFilters.vue"),
  },
  data() {
    return {
      actions: [
        {
          name: "Nova Forma de Pagamento",
          action: () => this.openModal("new", null),
        },
      ],
      headersFormaPgto: [
        {
          text: "Descrição",
          align: "center",
          sortable: false,
          value: "descricao",
        },
        {
          text: "Juros",
          align: "center",
          sortable: false,
          value: "juros",
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: "Ações",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
    };
  },
  methods: {
    openModal(type, data) {
      if (data != null) {
        this.$financeiro_formas_pgto.juros = data.juros;
      }
      this.$financeiro_formas_pgto.formas_pgto_AddEdit = type;
      if (type == "edit") {
        this.$financeiro_formas_pgto.cadastro.idforma_pag = data.idforma_pag;
        this.$financeiro_formas_pgto.cadastro.ordem = data.ordem;
        this.$financeiro_formas_pgto.cadastro.descricao = data.descricao;
        this.$financeiro_formas_pgto.cadastro.status = data.status;
        this.$financeiro_formas_pgto.cadastro.juros = data.juros;
        this.$financeiro_formas_pgto.cadastro.valor_maximo = data.valor_max;
        this.$financeiro_formas_pgto.cadastro.valor_minimo = data.valor_min;
        this.$financeiro_formas_pgto.cadastro.parcelas = data.num_parcelas;
        this.$financeiro_formas_pgto.cadastro.tipo = data.tipo;
      }
      this.$financeiro_formas_pgto.add_formas = true;
    },
    searchLoja(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.nome_loja.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
  },
  computed: {
    isLoja() {
      return this.$financeiro_formas_pgto.filter.canal_venda == "LOJA";
    },
  },
  mounted() {
    this.$financeiro_formas_pgto.getFormasPgto();
    this.$financeiro_formas_pgto.getModosPgto();
    this.$loja_gerenciar.getAllLojas();
  },
  destroyed() {
    this.$financeiro_formas_pgto.limparFiltros();
  },
};
</script>
<style scoped>
.formas-pagamento-table {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 20px;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fff;
}

.produtos-gerenciar-button1 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.produtos-gerenciar-button2 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  position: relative;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}
</style>
